
    import I18n from '@canvas/i18n/i18nObj';
    
      import 'translations/publish_cloud';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('publish_cloud');
  